import React from 'react';
import cx from 'classnames';
import SplitView from '../../../../split-view/split-view';
import { RobotFieldPane } from '../../../__field-pane/robot__field-pane';
import { RobotBlocklyCode } from '../../../__blockly/robot__blockly-code';
import RobotError from '../../../__error/robot__error';
import RobotInfo from '../../../__info/robot__info';
import RobotTabs, { RobotTabsContent } from '../../../__tabs/robot__tabs';
import { ROBOT_TABS } from '../../../robot.types';
import { useRobotSelector } from '../../../context';
import { Blockly } from '../../../__code-container/robot__code-container';
import { ROBOT_FIELD_MIN_WIDTH } from '../../../consts';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import styles from './robot_view_blockly-python_desktop.module.scss';

export const RobotViewBlocklyPythonDesktop = () => {
    const teacherMode = useRobotSelector((store) => store.teacherMode);

    return (
        <SplitView
            className={cx(styles.robot, 'qa_robot')}
            initialSizes={[0.3, 0.4, 0.3]}
            minSizes={[ROBOT_FIELD_MIN_WIDTH, 360, 360]}
        >
            <RobotFieldPane withSandbox={!teacherMode} />
            <Blockly className={styles.blockly} />
            <div className={cx(styles.right, 'qa_robot-editor')}>
                <RobotTabs />
                <RobotTabsContent>
                    {{
                        [ROBOT_TABS.INFO]: (
                            <div
                                className={cx(
                                    styles.info,
                                    { [styles.info_teacher]: teacherMode },
                                    'qa_robot-blockly-editor'
                                )}
                            >
                                <RobotInfo />
                            </div>
                        ),
                        [ROBOT_TABS.CODE]: (
                            <div className={cx(styles.code, { [styles.code_teacher]: teacherMode })}>
                                <RobotError className={styles.error} />
                                <RobotBlocklyCode />
                            </div>
                        ),
                    }}
                </RobotTabsContent>
            </div>
        </SplitView>
    );
};
